import { Routes } from '@angular/router';

import {
  AuthenticationGuard,
  HomeRedirectGuard,
  UnsavedChangeGuard,
} from '@shared/lib/guards';

export const routes: Routes = [
  {
    path: '',
    canActivate: [HomeRedirectGuard],
    loadComponent: async () =>
      import('./pages/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'dashboard',
    title: 'Dashboard - myWalden',
    canActivate: [AuthenticationGuard],
    loadComponent: async () =>
      import('./pages/dashboard/dashboard.component').then(
        m => m.DashboardComponent,
      ),
  },
  {
    path: 'academics',
    title: 'Academics - myWalden',
    canActivate: [AuthenticationGuard],
    loadComponent: async () =>
      import('./pages/academics/academics.component').then(
        m => m.AcademicsComponent,
      ),
  },
  {
    path: 'finances',
    title: 'Finances - myWalden',
    canActivate: [AuthenticationGuard],
    loadComponent: async () =>
      import('./pages/finances/finances.component').then(
        m => m.FinancesComponent,
      ),
  },
  {
    path: 'record-registration',
    title: 'Record and registration - myWalden',
    canActivate: [AuthenticationGuard],
    canDeactivate: [UnsavedChangeGuard],
    loadComponent: async () =>
      import('./pages/record-registration/record-registration.component').then(
        m => m.RecordRegistrationComponent,
      ),
  },
  {
    path: 'field-experience',
    title: 'Field experience - myWalden',
    canActivate: [AuthenticationGuard],
    loadComponent: async () =>
      import('./pages/field-experience/field-experience.component').then(
        m => m.FieldExperienceComponent,
      ),
  },
  {
    path: 'career-resources',
    title: 'Career Resources - myWalden',
    canActivate: [AuthenticationGuard],
    loadComponent: async () =>
      import('./pages/career-resources/career-resources.component').then(
        m => m.CareerResourcesComponent,
      ),
  },
  {
    path: 'support',
    title: 'Support - myWalden',
    canActivate: [AuthenticationGuard],
    loadComponent: async () =>
      import('./pages/support/support.component').then(m => m.SupportComponent),
  },
  {
    path: 'my-account',
    title: 'My account - myWalden',
    canActivate: [AuthenticationGuard],
    loadComponent: async () =>
      import('./pages/my-account/my-account.component').then(
        m => m.MyAccountComponent,
      ),
  },
  {
    path: 'search',
    title: 'Search results - myWalden',
    canActivate: [AuthenticationGuard],
    loadComponent: async () =>
      import('./pages/search-result/search-result.component').then(
        m => m.SearchResultComponent,
      ),
  },
  {
    path: 'page-not-found',
    title: 'Page not found - myWalden',
    loadComponent: async () =>
      import('./pages/not-found/not-found.component').then(
        m => m.NotFoundComponent,
      ),
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
  },
];
